export var CREATE_VIEW_REQUEST = 'src/ViewNew/CREATE_VIEW_REQUEST';
export var CREATE_VIEW_SUCCESS = 'src/ViewNew/CREATE_VIEW_SUCCESS';
export var CREATE_VIEW_FAILURE = 'src/ViewNew/CREATE_VIEW_FAILURE';
